import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import {
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiUpload,
  FiLock,
} from "react-icons/fi";
import { ToastContainer } from "react-toastify";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
const NewTicket = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  const [wait, setWait] = useState(0);

  const [userData, setUserData] = useState([]);

  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isRequeteAccordionOpen, setIsRequeteAccordionOpen] = useState(true);
  const toggleRequeteAccordion = () => {
    setIsRequeteAccordionOpen(!isRequeteAccordionOpen);
  };
  const [isSuiviAccordionOpen, setIsSuiviAccordionOpen] = useState(true);
  const toggleSuiviAccordion = () => {
    setIsSuiviAccordionOpen(!isSuiviAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  //Pièce jointe
  const [selectedFichier, setSelectedFichier] = useState("");

  const handleFichierChange = (event) => {
    const newFile = event.target.files[0]; // Récupère le nouveau fichier
    if (newFile) {
      setSelectedFichier(newFile);
    } else {
      setSelectedFichier(null);
      console.log("Aucun fichier sélectionné");
    }
  };
  // Hashtag #
  const [selectedHashTag, setSelectedHashTag] = useState("");
  // Titre de la requete
  const [selectedTitreRequete, setSelectedTitreRequete] = useState("");
  const handleTitreRequeteChange = (event) => {
    setSelectedTitreRequete(event.target.value);
  };
  // Type de la requete
  const [selectedTypeRequete, setSelectedTypeRequete] = useState("");
  const [typeRequeteData, setTypeData] = useState({ data: [] });
  const [selectedRoleAccount, setSelectedRoleAccount] = useState("");
  const handleselectedRoleAccountChange = (event) => {
    setSelectedRoleAccount(event.target.value);
  };
  const handleTypeRequeteChange = (event) => {
    setSelectedTypeRequete(event);
  };
  const getTypeRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_types`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setTypeData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeRequeteOptions = () => {
    return [
      {
        options: typeRequeteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Description
  const [selectedDescription, setSelectedDescription] = useState("");
  const handleDescriptionChange = (event) => {
    setSelectedDescription(event.target.value);
  };
  // Url
  const [selectedUrl, setSelectedUrl] = useState("");
  const handleUrlChange = (event) => {
    setSelectedUrl(event.target.value);
  };
  // Criticite
  const [selectedCriticite, setSelectedCriticite] = useState("");
  const [criticiteData, setCriticiteData] = useState({ data: [] });
  const handleCriticiteChange = (event) => {
    setSelectedCriticite(event);
  };
  const getCriticite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/criticities`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCriticiteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCriticiteOptions = () => {
    return [
      {
        options: criticiteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Compte
  const [selectedCompte, setSelectedCompte] = useState("");
  const [compteData, setCompteData] = useState({ data: [] });
  const handleCompteChange = (event) => {
    setSelectedCompte(event);
  };
  const getCompte = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_users`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setCompteData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCompteOptions = () => {
    return [
      {
        options: compteData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Commentaire
  const [selectedCommentaire, setSelectedCommentaire] = useState("");
  const handleCommentaireChange = (event) => {
    setSelectedCommentaire(event.target.value);
  };
  // Budget
  const [selectedBudget, setSelectedBudget] = useState("");
  const handleBudgetChange = (event) => {
    setSelectedBudget(event.target.value);
  };
  // StatutLiv
  const [selectedStatutLiv, setSelectedStatutLiv] = useState("");
  const [statutLivData, setSelectedStatutLivData] = useState({ data: [] });
  const handleStatutLivChange = (event) => {
    setSelectedStatutLiv(event);
  };
  const getStatutLiv = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/delivery_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutLivData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutLivOptions = () => {
    return [
      {
        options: statutLivData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // StatutReq
  const [selectedStatutReq, setSelectedStatutReq] = useState({
    label: "En cours",
    id: 1,
  });
  const [statutReqData, setSelectedStatutReqData] = useState({ data: [] });
  const handleStatutReqChange = (event) => {
    setSelectedStatutReq(event);
  };
  const getStatutRequete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_tickets/fx_ticket_status`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setSelectedStatutReqData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutReqOptions = () => {
    return [
      {
        options: statutReqData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Temps
  const [selectedTemps, setSelectedTemps] = useState("");
  const handleTempsChange = (event) => {
    setSelectedTemps(event.target.value);
  };
  // DateLiv
  const [selectedDateLiv, setSelectedDateLiv] = useState("");
  // DateCorr
  const [selectedDateCorr, setSelectedDateCorr] = useState("");

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Tickets | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={{ ...(type_compte == "client" ? navStyleClient : navStyle) }}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails Ticket"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedTitreRequete === "" ||
      selectedDescription === "" ||
      selectedTypeRequete === null ||
      selectedCriticite === null ||
      selectedUrl === "" ||
      (selectedCompte === "" && type_compte == "builder")
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        setLoading(true);

        const formData = new FormData();

        formData.append("name", selectedTitreRequete);
        formData.append("fx_ticket_type_id", selectedTypeRequete?.value);
        formData.append("criticity", selectedCriticite?.value);
        formData.append("url", selectedUrl);
        formData.append("description", selectedDescription);
        //formData.append("fx_ticket_status_id", selectedStatutReq);
        formData.append("commentaires_support", selectedCommentaire);
        type_compte == "builder"
          ? formData.append("fx_user_id", selectedCompte?.value)
          : null;
        formData.append("fichier", selectedFichier);
        formData.append("role_or_account_used", selectedRoleAccount);
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_tickets/`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: formData,
          }
        );

        if (response.ok) {
          console.log("POSt request successful");
          const responseData = await response.json();
          navigate(`${backUrl}/fx_tickets/${responseData.id}`);
        } else {
          console.error("POST request failed");
          const responseData = await response.json();

          if (responseData && responseData.fx_ticket_validation) {
            const errors = responseData?.fx_ticket_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        await getTypeRequete();
        await getStatutRequete();
        await getCompte();
        await getCriticite();
        await getStatutLiv();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }
  const handleGoBack = () => {
    window.history.back(); // Cela vous ramènera en arrière dans l'historique du navigateur
  };
  const type_compte = localStorage.getItem("typeDeCompte_" + api);
  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row className="mb-2">
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/fx_tickets/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Tickets
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        "Nouveau"
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row className="mb-2">
                            <Col sm="12">
                              <Card
                                className="shadow-sm border-0 overflow-hidden mb-4"
                                style={{ borderRadius: "12px" }}
                              >
                                {/* En-tête cliquable */}
                                <div
                                  className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                  style={{
                                    background: "#555B21",
                                    letterSpacing: "0.5px",
                                    cursor: "pointer",
                                    userSelect: "none",
                                  }}
                                  onClick={toggleRequeteAccordion}
                                >
                                  <div className="d-flex align-items-center">
                                    <span style={{ fontSize: "0.82rem" }}>
                                      Requête
                                    </span>
                                  </div>
                                  {isRequeteAccordionOpen ? (
                                    <FiChevronUp size={16} />
                                  ) : (
                                    <FiChevronDown size={16} />
                                  )}
                                </div>

                                <Collapse isOpen={isRequeteAccordionOpen}>
                                  <CardBody className="p-0">
                                    <div
                                      className="fields-container"
                                      style={{ paddingBottom: "8px" }}
                                    >
                                      {/* Titre de la requête */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid #dc3545",
                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#ffe6e6";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Titre de la requête
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            style={{ position: "relative" }}
                                          >
                                            <input
                                              className="form-control form-control-sm shadow-sm border-0"
                                              type="text"
                                              value={selectedTitreRequete}
                                              required
                                              onChange={
                                                handleTitreRequeteChange
                                              }
                                              style={{
                                                fontSize: "0.8rem",
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "6px",
                                                padding: "0.375rem 0.75rem",
                                                height: "32px",
                                              }}
                                            />
                                            <FiEdit3
                                              size={12}
                                              className="position-absolute text-muted"
                                              style={{
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                                opacity: 0.9,
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* Type de requête */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid #dc3545",
                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#ffe6e6";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Type de requête
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col xs={12} md={8}>
                                            <Select
                                              value={selectedTypeRequete}
                                              onChange={handleTypeRequeteChange}
                                              options={renderTypeRequeteOptions()}
                                              isClearable={true}
                                              classNamePrefix="select2-selection"
                                              menuPortalTarget={document.body}
                                              styles={styles(
                                                selectedTypeRequete === null ||
                                                  selectedTypeRequete === ""
                                              )}
                                            />
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* Compte utilisé */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid transparent",

                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#e3f2fd";
                                          e.currentTarget.style.borderLeftColor =
                                            "#007bff";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "transparent";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Compte utilisé
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            style={{ position: "relative" }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedRoleAccount}
                                              onChange={
                                                handleselectedRoleAccountChange
                                              }
                                              className="form-control form-control-sm shadow-sm border-0"
                                              style={{
                                                fontSize: "0.8rem",
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "6px",
                                                padding: "0.375rem 0.75rem",
                                                height: "32px",
                                              }}
                                            />
                                            <FiEdit3
                                              size={12}
                                              className="position-absolute text-muted"
                                              style={{
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                                opacity: 0.9,
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* URL du bug */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid #dc3545",
                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#ffe6e6";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                URL du bug
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            style={{ position: "relative" }}
                                          >
                                            <input
                                              type="text"
                                              value={selectedUrl}
                                              onChange={handleUrlChange}
                                              className="form-control form-control-sm shadow-sm border-0"
                                              style={{
                                                fontSize: "0.8rem",
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "6px",
                                                padding: "0.375rem 0.75rem",
                                                height: "32px",
                                              }}
                                            />
                                            <FiEdit3
                                              size={12}
                                              className="position-absolute text-muted"
                                              style={{
                                                right: "8px",
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                                opacity: 0.9,
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* Description */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid #dc3545",
                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#ffe6e6";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                      >
                                        <Row className="align-items-start g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted pt-1">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Description
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={8}
                                            style={{ position: "relative" }}
                                          >
                                            <textarea
                                              type="text"
                                              rows={5}
                                              value={selectedDescription}
                                              onChange={handleDescriptionChange}
                                              className="form-control form-control-sm shadow-sm border-0"
                                              style={{
                                                fontSize: "0.8rem",
                                                backgroundColor: "#f8f9fa",
                                                borderRadius: "6px",
                                                padding: "0.375rem 0.75rem",
                                                resize: "vertical",
                                              }}
                                            />
                                            <FiEdit3
                                              size={12}
                                              className="position-absolute text-muted"
                                              style={{
                                                right: "8px",
                                                top: "8px",
                                                pointerEvents: "none",
                                                opacity: 0.9,
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* Pièce jointe */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid transparent",

                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#e3f2fd";
                                          e.currentTarget.style.borderLeftColor =
                                            "#007bff";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "transparent";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Pièce jointe
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col xs={12} md={8}>
                                            <div className="position-relative">
                                              <input
                                                type="file"
                                                onChange={handleFichierChange}
                                                className="form-control form-control-sm shadow-sm border-0"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiUpload
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>

                                      {/* Criticité */}
                                      <div
                                        className="field-item px-2 py-1 mb-1"
                                        style={{
                                          backgroundColor: "white",
                                          transition: "all 0.15s ease",
                                          borderLeft: "3px solid #dc3545",
                                          position: "relative",
                                          marginBottom: "1px",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "#ffe6e6";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor =
                                            "white";
                                          e.currentTarget.style.borderLeftColor =
                                            "#dc3545";
                                        }}
                                      >
                                        <Row className="align-items-center g-1">
                                          <Col xs={12} md={4}>
                                            <div className="d-flex align-items-center small text-muted">
                                              <span
                                                className="fw-medium"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  letterSpacing: "0.2px",
                                                }}
                                              >
                                                Criticité
                                              </span>
                                              <span className="ms-1 text-primary">
                                                :
                                              </span>
                                            </div>
                                          </Col>
                                          <Col xs={12} md={8}>
                                            <Select
                                              value={selectedCriticite}
                                              onChange={handleCriticiteChange}
                                              options={renderCriticiteOptions()}
                                              isClearable={true}
                                              classNamePrefix="select2-selection"
                                              menuPortalTarget={document.body}
                                              styles={styles(
                                                selectedCriticite === null ||
                                                  selectedCriticite === ""
                                              )}
                                            />
                                          </Col>
                                        </Row>
                                      </div>
                                    </div>
                                  </CardBody>
                                </Collapse>
                              </Card>
                            </Col>

                            <Row className="mb-2">
                              <Col sm="12">
                                {" "}
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleSuiviAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Suivi
                                      </span>
                                    </div>
                                    {isSuiviAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isSuiviAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Statut de la requête */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#f0f0f0";
                                            e.currentTarget.style.borderLeftColor =
                                              "#6c757d";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Statut de la requête
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div
                                                style={{ position: "relative" }}
                                              >
                                                <Select
                                                  value={selectedStatutReq}
                                                  onChange={
                                                    handleStatutReqChange
                                                  }
                                                  options={renderStatutReqOptions()}
                                                  isClearable={true}
                                                  isDisabled={true}
                                                  classNamePrefix="select2-selection"
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  styles={{
                                                    control: (provided) => ({
                                                      ...provided,
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#e9ecef",
                                                      borderRadius: "6px",
                                                      border: "none",
                                                      minHeight: "32px",
                                                      padding: "0 0.25rem",
                                                      cursor: "not-allowed",
                                                    }),
                                                    option: (
                                                      provided,
                                                      state
                                                    ) => ({
                                                      ...provided,
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        state.isSelected
                                                          ? "#007bff"
                                                          : state.isFocused
                                                          ? "#e3f2fd"
                                                          : "white",
                                                    }),
                                                    menuPortal: (provided) => ({
                                                      ...provided,
                                                      zIndex: 9999,
                                                    }),
                                                    singleValue: (
                                                      provided
                                                    ) => ({
                                                      ...provided,
                                                      color: "#6c757d",
                                                    }),
                                                  }}
                                                />
                                                <FiLock
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "32px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.6,
                                                    zIndex: 1,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Crée par (conditionnel) */}
                                        {type_compte === "builder" && (
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Créé par
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={selectedCompte}
                                                  onChange={handleCompteChange}
                                                  options={renderCompteOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  styles={styles(
                                                    selectedCompte === null ||
                                                      selectedCompte === ""
                                                  )}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default NewTicket;
